import { jsxs as w, jsx as o } from "react/jsx-runtime";
import { useRef as y, useState as d, useEffect as g } from "react";
import s from "../../components/Button/index.js";
import q from "../../icons/Minus.js";
import L from "../../icons/Plus.js";
const D = "forma-ui__quantity__root", R = "forma-ui__quantity__button", T = "forma-ui__quantity__buttonIcon", U = "forma-ui__quantity__input", t = {
  root: D,
  button: R,
  buttonIcon: T,
  input: U
}, A = ({ value: a = 0, max: _ = 100, step: c = 1, onChange: M, disabled: r }) => {
  const i = y(null), l = y(null), m = y(!1), [I, f] = d(a);
  g(() => {
    f(a);
  }, [a]);
  const x = (n, e) => typeof c == "function" ? c(n, e) : c, N = (n) => {
    f((e) => {
      const u = x(e, n), h = n ? Math.min(e + u, _) : Math.max(e - u, 0);
      return M(h), h;
    });
  }, S = () => {
    l.current && clearTimeout(l.current), i.current && clearInterval(i.current);
  }, b = (n) => {
    r || (m.current = !0, N(n), l.current = setTimeout(() => {
      i.current = setInterval(() => N(n), 100);
    }, 300));
  }, p = () => {
    m.current = !1, S();
  }, v = () => {
    m.current && p();
  };
  return /* @__PURE__ */ w("div", { className: t.root, children: [
    /* @__PURE__ */ o(
      s,
      {
        viewStyle: "tertiary",
        className: t.button,
        onMouseDown: () => b(!1),
        onMouseUp: p,
        onMouseLeave: v,
        iconClassName: t.buttonIcon,
        icon: /* @__PURE__ */ o(q, {}),
        disabled: r
      }
    ),
    /* @__PURE__ */ o(
      "input",
      {
        type: "text",
        className: t.input,
        value: I,
        pattern: "[0-9]*",
        onChange: (n) => {
          const e = Number(n.target.value.replaceAll(/[^0-9]/g, "")), u = Math.min(e, _);
          f(u), M(u);
        },
        disabled: r
      }
    ),
    /* @__PURE__ */ o(
      s,
      {
        viewStyle: "tertiary",
        className: t.button,
        onMouseDown: () => b(!0),
        onMouseUp: p,
        onMouseLeave: v,
        iconClassName: t.buttonIcon,
        icon: /* @__PURE__ */ o(L, {}),
        disabled: r
      }
    )
  ] });
}, B = () => /* @__PURE__ */ w("div", { className: t.root, children: [
  /* @__PURE__ */ o(
    s,
    {
      viewStyle: "tertiary",
      className: t.button
    }
  ),
  /* @__PURE__ */ o("span", { className: t.input }),
  /* @__PURE__ */ o(
    s,
    {
      viewStyle: "tertiary",
      className: t.button
    }
  )
] });
export {
  B as QuantityPlaceholder,
  A as default
};
